import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SaleItemService } from '../sale-item.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-shop-price-popup',
  templateUrl: './shop-price-popup.component.html',
  styleUrl: './shop-price-popup.component.scss',
  standalone: false
})
export class ShopPricePopupComponent implements OnInit {
  displayedColumns: string[] = ['serialNo', 'shopName', 'price'];
  dataSource = new MatTableDataSource<any>([]);
  itemName: string = '';
  saleItemId: number;
  searchText: string = '';

  constructor(
    public dialogRef: MatDialogRef<ShopPricePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private saleItemService: SaleItemService
  ) {
    this.itemName = data.itemName;
    this.saleItemId = data.saleItemId;
  }

  ngOnInit(): void {
    this.loadShopPrices();
    
    // Configure client-side filtering
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const searchStr = filter.toLowerCase();
      return data.shop_name.toLowerCase().includes(searchStr);
    };
  }

  loadShopPrices(): void {
    const request = {
      sale_item_id: this.saleItemId,
      search: {
        filters: {
          simpleSearch: '', // Fetch all active prices
          advSearch: [],
          scope: {
            limit: 10000,
            offset: 0
          }
        }
      }
    };

    this.saleItemService.getShopPrices(request).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.dataSource.data = response.data.shop_prices || [];
          // Apply existing search text if any
          this.onSearch();
        }
      },
      error: (error) => {
        console.error('Error fetching shop prices:', error);
      }
    });
  }

  onSearch(): void {
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }

  close(): void {
    this.dialogRef.close();
  }
}
